import ContactForm from "./components/ContactForm.svelte"

// get target element, site_id and form_id from data attributes of current script tag (by query form data-name="contact-form")
const scriptTag = document.querySelector('script[data-name="contact-form"]') as HTMLScriptElement
const targetElement = document.querySelector(scriptTag.dataset.target)
const cryptcha_site_id = scriptTag.dataset.cryptchaSiteId
const form_id = scriptTag.dataset.formId
if (targetElement && cryptcha_site_id && form_id) {
    // render ContactForm component
    new ContactForm({
        target: targetElement,
        props: {
            cryptcha_site_id: cryptcha_site_id,
            form_id: form_id,
        },
    })
}

export default { ContactForm }
